module.exports = __webpack_public_path__ + "media/assets/icons/hamburger-white-2144ef9696da5efccf981fd3ea034aa7.svg";